// Unpublished Work © 2021-2024 Deere & Company.

export const GRAPH_COLORS = [
    '#0066ad', '#16c06b', '#f2a33c', '#8a0000',
    '#05a1c9', '#ffff82', '#7464d0', '#5f0066',
    '#47c2b7', '#00ffc3', '#99681e', '#7b9cff',
    '#8a0000', '#939', '#bfabcb', '#d2ad79'
];
